import { useMemo } from 'react';

import PropTypes from 'prop-types';
import {
  LineChart,
  XAxis,
  YAxis,
  Tooltip,
  Line,
  CartesianGrid,
  ResponsiveContainer
} from 'recharts';

import { calculateDomainAndTicks, xTickFormatter, yTickFormatter } from '#client/utils/chart';

import CustomTooltip from './CustomTooltip';

import { COLOR_HISTORY_BALANCE } from '../constants/colors';

const INTERVAL_DIVISOR = 5;

export default function Chart({ dailyBalance, height = 200 }) {
  const interval = useMemo(
    () => Math.floor(dailyBalance.length / INTERVAL_DIVISOR),
    [dailyBalance]
  );

  const { yDomain, yTicks } = useMemo(() => calculateDomainAndTicks(dailyBalance), [dailyBalance]);

  return (
    <ResponsiveContainer
      debounce={100}
      height={height}
    >
      <LineChart
        data={dailyBalance}
        margin={{
          top: 10,
          right: 20,
          left: 0,
          bottom: 0
        }}
      >
        <CartesianGrid
          horizontal={false}
          stroke={COLOR_HISTORY_BALANCE.Y_TICK}
        />
        <XAxis
          axisLine={false}
          dataKey="date"
          interval={interval}
          style={{
            fontSize: '11px'
          }}
          tickFormatter={xTickFormatter}
          tickLine={false}
        />
        <YAxis
          axisLine={false}
          domain={yDomain}
          style={{
            fontSize: '11px'
          }}
          tickFormatter={yTickFormatter}
          tickLine={false}
          ticks={yTicks}
        />
        <Tooltip
          content={CustomTooltip}
          cursor={{ fill: COLOR_HISTORY_BALANCE.TOOLTIP_BACKGROUND }}
          wrapperStyle={{ outline: 'none' }}
        />
        <Line
          activeDot={{
            r: 6,
            stroke: 'black',
            strokeWidth: 2
          }}
          dataKey="amount"
          dot={false}
          stroke={COLOR_HISTORY_BALANCE.LINE}
          strokeWidth={3}
          type="monotone"
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

Chart.propTypes = {
  dailyBalance: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired,
  height: PropTypes.number
};
